export const getQueryAsString = (query: Record<string, any>): string => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => params.append(key, v));
    } else if (value !== undefined) {
      params.append(key, String(value));
    }
  });
  return params.toString();
}

export const getHrefAsQueryString = (href: {pathname:string, query: Record<string, any>}): string => {
 return getQueryAsString(href.query)?`${href.pathname}?${getQueryAsString(href.query)}`:`${href.pathname}`;
}